import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import { APIErrorResponse } from '@/types'
import { getUseInternalHoursLogsKey } from './useInternalHoursLogs'

export const useDeleteInternalHoursLog = (
  id: number
): UseMutationResult<unknown, APIErrorResponse, void> => {
  const client = useApiClient()
  const queryClient = useQueryClient()
  const listKey = getUseInternalHoursLogsKey()

  return useMutation(
    () =>
      client
        .delete(`/hours_reporting/internal-hours/${id}/`)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(listKey)
      },
    }
  )
}
